import axios from "axios";

// Resolve a base de API de forma segura:
// - Em dev/preview: usa REACT_APP_BACKEND_URL (configurado no .env)
// - Em produção com domínio customizado: se REACT_APP_BACKEND_URL apontar para
//   um host DIFERENTE do atual, cai para path relativo (/api) — same-origin via ingress.
//   Isso evita "Network Error" causado por CORS + cookies cross-origin.
function resolveBaseURL() {
  const envUrl = process.env.REACT_APP_BACKEND_URL || "";
  if (typeof window === "undefined") return `${envUrl}/api`;
  try {
    if (!envUrl) return "/api";
    const envOrigin = new URL(envUrl).origin;
    if (envOrigin === window.location.origin) return `${envUrl}/api`;
    // Cross-origin → use relative path (backend served same host via /api)
    return "/api";
  } catch {
    return "/api";
  }
}

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: resolveBaseURL(),
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Also attach token from localStorage as fallback (cookies may be blocked cross-site in preview)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vv_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Erro inesperado";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}

export const BRAND = {
  LOGO: "https://customer-assets.emergentagent.com/job_volei-gestao-turmas/artifacts/1ht1wtlm_logo_volei_vida_sem_fundo.png",
  // Todos sem fundo (PNG transparente)
  MANGUITO: "https://customer-assets.emergentagent.com/job_volei-gestao-turmas/artifacts/hfjeoong_Editedimage_1776817130537-removebg-preview.png",
  MANGUITA: "https://customer-assets.emergentagent.com/job_volei-gestao-turmas/artifacts/av8mqhsn_Editedimage_1776818682547-removebg-preview.png",
  MANGUITO_SAQUE: "https://customer-assets.emergentagent.com/job_volei-gestao-turmas/artifacts/dhqxss82_Editedimage_1776818779079-removebg-preview.png",
  MANGUITO_FORCA: "https://customer-assets.emergentagent.com/job_volei-gestao-turmas/artifacts/hfjeoong_Editedimage_1776817130537-removebg-preview.png",
  DUO_ACAO: "https://customer-assets.emergentagent.com/job_volei-gestao-turmas/artifacts/xc80ixd3_Editedimage_1776818713137-removebg-preview.png",
  MANGUITA_COACH: "https://customer-assets.emergentagent.com/job_volei-gestao-turmas/artifacts/lnn2hym6_Editedimage_1776818688136-removebg-preview.png",
  MANGUITA_TOQUE: "https://customer-assets.emergentagent.com/job_volei-gestao-turmas/artifacts/av8mqhsn_Editedimage_1776818682547-removebg-preview.png",
  MANGUITA_FORCA: "https://customer-assets.emergentagent.com/job_volei-gestao-turmas/artifacts/bxob7nah_Editedimage_1776818671627-removebg-preview.png",
};
